<section class="plan-page" @fadeUp>
  <!-- Header (consistent with onboarding step style) -->
  <div class="plan-header">
    <div class="onboarding-badge">Step 6 of 6</div>
    <h1 class="plan-title">Choose your plan</h1>
    <p class="plan-subtitle">
      Start free, no credit card required — upgrade anytime.
    </p>

    <!-- Billing toggle -->
    <div class="billing-toggle" role="group" aria-label="Billing period">
      <button
        type="button"
        class="billing-option"
        [class.active]="billingPeriod === 'monthly'"
        (click)="setBillingPeriod('monthly')"
      >
        Monthly
      </button>
      <button
        type="button"
        class="billing-option"
        [class.active]="billingPeriod === 'annual'"
        (click)="setBillingPeriod('annual')"
      >
        Annual
        <span class="billing-save">Save more</span>
      </button>
    </div>
  </div>

  <!-- Cards -->
  <div class="plans-grid" [@staggerCards]="billingPeriod">

    <div
      *ngFor="let plan of plans"
      class="plan-card"
      [class.plan-card--featured]="plan.badge"
    >
      <div class="card-inner">
        <div class="badge-slot">
          <span class="plan-badge" *ngIf="plan.badge">{{ plan.badge }}</span>
        </div>

        <div class="card-top">
          <div class="plan-name">{{ plan.name }}</div>

          <!-- Free -->
          <ng-container *ngIf="plan.monthlyPrice === 0; else paidPricing">
            <div class="plan-pricing">
              <span class="price-current">$0</span>
              <span class="price-meta"> / month</span>
            </div>
            <div class="billing-info">Free forever</div>
          </ng-container>

          <!-- Paid -->
          <ng-template #paidPricing>
            <div class="plan-pricing">
              <span class="price-old" *ngIf="plan.monthlyOriginalPrice">${{ plan.monthlyOriginalPrice }}</span>
              <span class="price-current">${{ getPrice(plan) }}</span>
              <span class="price-meta"> / user / month</span>
            </div>
            <div class="billing-info">
              {{ billingPeriod === 'annual' ? 'billed annually' : 'billed monthly' }}
            </div>
          </ng-template>

          <div class="plan-note" *ngIf="plan.note">{{ plan.note }}</div>
        </div>

        <div class="divider"></div>

        <div class="includes-line" *ngIf="plan.includes">{{ plan.includes }}</div>

        <ul class="features-list">
          <li *ngFor="let f of plan.features" class="feature-item">
            <span class="check-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13 4.5L6.5 11L3.5 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            {{ f }}
          </li>
        </ul>

        <div class="card-cta">
          <!-- Free plan → start free trial endpoint -->
          <ng-container *ngIf="plan.cta === 'trial'; else salesCta">
            <button
              class="btn-primary btn-pill"
              [class.btn-loading]="isActivating"
              [disabled]="isActivating || hasUsedTrial"
              (click)="onPlanCta(plan)"
            >
              <span *ngIf="isActivating">Activating…</span>
              <span *ngIf="!isActivating && !hasUsedTrial">Get Started</span>
              <span *ngIf="!isActivating && hasUsedTrial">Current plan</span>
            </button>
          </ng-container>

          <!-- Companion / Enterprise → Talk to Sales -->
          <ng-template #salesCta>
            <button
              class="btn-pill"
              [class.btn-primary]="plan.badge"
              [class.btn-secondary]="!plan.badge"
              (click)="onPlanCta(plan)"
            >
              Talk to Sales
            </button>
          </ng-template>
        </div>
      </div>
    </div>

  </div>

  <p class="plan-footer-note">
    <a href="https://convverse.ai/contact-us" target="_blank" rel="noopener noreferrer">Questions? Talk to us →</a>
  </p>
</section>
